import { getBodegas, createBodega, updateBodega, deleteBodega } from '../models/bodegaModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase';
import { toasts } from "svelte-toasts";

export async function fetchBodegas(page, perPage) {
  try {
    const response = await getBodegas(page, perPage);
    return {
      bodega: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    console.error("Error fetching bodegas:", error);
    Swal.fire('Error', 'No se pudieron cargar las bodegas', 'error');
    return null;
  }
}

export async function saveBodega(bodega, currentBodegaId) {
  try {
    if (currentBodegaId) {
      await updateBodega(currentBodegaId, bodega);
      toasts.add({
        title: 'Éxito',
        description: 'Bodega guardada exitosamente',
        duration: 3000, // Duración de 3 segundos
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    } else {
      await createBodega(bodega);
      toasts.add({
        title: 'Éxito',
        description: 'Bodega creada exitosamente',
        duration: 3000, // Duración de 3 segundos
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    }
  } catch (error) {
    console.error("Error saving bodega:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar la bodega',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  }
}

export async function removeBodega(id) {
  try {
    await deleteBodega(id);
    toasts.add({
      title: 'Éxito',
      description: 'Bodega eliminada exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  } catch (error) {
    console.error("Error deleting bodega:", error);
    Swal.fire('Error', 'No se pudo eliminar la bodega', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'bodega'
export function subscribeToBodegas(searchQuery, handleSearch) {
  pb.collection('bodega').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(1); // Actualiza la lista con la primera página
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromBodegas() {
  pb.collection('bodega').unsubscribe('*');
}

export async function searchBodegas(query, page = 1, perPage = 10) {
  const response = await pb.collection('bodega').getList(page, perPage, {
    filter: `descrip ~ "${query}"`,
  });
  return {
    bodega: response.items,
    totalRecords: response.totalItems,
    currentPage: response.currentPage,
  };
}